import React from "react";
import HeartIcon from "@/assets/icons/favourite.svg?react";

interface FavouriteIconProps {
  className?: string;
  colorFilled?: string;
  colorOutlined?: string;
  size?: "base" | "xs" | "sm" | "md" | "lg" | "xl";
  isFavourite?: boolean;
  onClick?: (e: React.MouseEvent) => void;
}

export const FavouriteIcon = ({
                                       className = "",
                                       colorFilled = "text-black-400",
                                       colorOutlined = "text-black-400",
                                       size = "lg",
                                       isFavourite = false,
                                       onClick,
                                     }: FavouriteIconProps) => {
  const sizeClasses = {
    base: "w-5.5 h-5.5",
    xs: "w-4.5 h-4.5",
    sm: "w-5 h-5",
    md: "w-6.5 h-6.5",
    lg: "w-7.5 h-7.5",
    xl: "w-8.5 h-8.5",
  };

  return (
    <div
      onClick={onClick}
      className={`
        inline-block
        ${sizeClasses[size]}
        ${className}
      `}
    >
      <HeartIcon
        className={`
          w-full h-full transition-colors duration-200
          ${isFavourite ? colorFilled : colorOutlined}
          ${isFavourite ? "fill-current" : "fill-none"}
        `}
      />
    </div>
  );
};

export default FavouriteIcon;
